import { translate } from '@jsverse/transloco';
export enum AssessmentRisk {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    CRITICAL = 'CRITICAL',
}

export class AssessmentRiskHelper {
    static getAssessmentRiskLocale(risk: AssessmentRisk): string {
        switch (risk) {
            case AssessmentRisk.LOW:
                return translate('CORE.RISKS.LOW');
            case AssessmentRisk.MEDIUM:
                return translate('CORE.RISKS.MEDIUM');
            case AssessmentRisk.HIGH:
                return translate('CORE.RISKS.HIGH');
            case AssessmentRisk.CRITICAL:
                return translate('CORE.RISKS.CRITICAL');
            default:
                return risk;
        }
    }
}
